import { styled, FormLabel, OutlinedInput } from "@mui/material";

export const ResponsiveFormLabel = styled(FormLabel)(({ theme }) => ({
  fontWeight: 500,
  marginBottom: "5px",
  display: "block",
  fontFamily: "Outfit",
  whiteSpace: "nowrap",
  // Responsive Width
  width: "100%", // Full width on mobile
  [theme.breakpoints.up("sm")]: {
    width: "250px",
  },
  [theme.breakpoints.up("md")]: {
    width: "300px",
  },
  [theme.breakpoints.up("lg")]: {
    width: "350px",
  },

  // Responsive font size using breakpoints
  fontSize: "14px", // Default for xs
  [theme.breakpoints.up("sm")]: {
    fontSize: "13px",
  },
  [theme.breakpoints.between("md", "lg")]: {
    fontSize: "14px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "16px",
  },
}));

export const ResponsiveOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  height: "40px",
  borderWidth: "2px",
  marginBottom: "16px",
   fontFamily: "Outfit",
   fontWeight:'bold',
  // Responsive Width:
  width: "100%", // Default to full width
  [theme.breakpoints.up("sm")]: {
    width: "250px",
  },
  [theme.breakpoints.up("md")]: {
    width: "300px",
  },
  [theme.breakpoints.up("lg")]: {
    width: "350px",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "2px",
  },

  // Breakpoints for height
  [theme.breakpoints.up("sm")]: {
    height: "45px",
  },
  [theme.breakpoints.up("md")]: {
    height: "50px",
  },
  [theme.breakpoints.up("lg")]: {
    height: "45px",
  },

  // Responsive font size
  fontSize: "14px",
  [theme.breakpoints.up("sm")]: {
    fontSize: "13px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "14px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "16px",
  },

  // Responsive padding
  padding: "5px 10px",
  [theme.breakpoints.up("sm")]: {
    padding: "6px 12px",
  },
  [theme.breakpoints.up("md")]: {
    padding: "8px 14px",
  },
  [theme.breakpoints.up("lg")]: {
    padding: "10px 16px",
  },
}));
